/* Mit Motiv · kurven, runde 3 (9/10-2026 — Caspers ordre: flere forbedringer til kurv og checkout)
   1) «Sæt plakaten i ramme» (snippets/mm-kurv-ramme): tilbuddet vises først, når Essential Upsells tilbud for rammen
      findes på siden og giver mindst den rabat, kurven lover (data-pct) — ellers forbliver det skjult. Rammen lægges i
      kurven med appens mærker (som i Plakatstudiet), og kurv-skuffen tegnes forfra. På kurv-siden genindlæses siden.
   2) «Lav én plakat mere» (snippets/mm-kurv-maengde) i skuffen på selve Plakatstudiet: luk skuffen og gå op til studiet.
   Kurv-skuffen tegnes forfra ved hver ændring (Dawn: innerHTML) — derfor lyttes der på hele siden, og tilbuddet tjekkes
   igen, hver gang skuffen eller kurv-siden ændrer sig. */
(() => {
  // skuffen og kurv-siden indlæser begge filen på /cart — kun én gang (ellers to rammer pr. tryk)
  if (window.mmKurvPlus) return;
  window.mmKurvPlus = true;
  const d = document;
  const saet = (el, t) => { if (el && el.textContent !== t) el.textContent = t; };   // kun ved ændring (ellers en uendelig observer-løkke)
  const funnels = () => {
    const el = d.querySelector('[upsell-app-data]');
    if (!el) return [];
    try { return JSON.parse(el.getAttribute('upsell-app-data')).funnels || []; } catch (e) { return []; }
  };
  const tilbud = (vid, fns) => fns.find((f) => f.upsell && (f.upsell.specificProducts || []).some((p) => (p.variantIds || []).some((v) => String(v).endsWith('/' + vid))));

  const vaelg = (k) => {
    const box = k.closest('[data-mm-ramme]');
    if (!box) return;
    box.querySelectorAll('[data-mm-ramme-valg]').forEach((x) => { const on = String(x === k); if (x.getAttribute('aria-checked') !== on) x.setAttribute('aria-checked', on); });
    const knap = box.querySelector('[data-mm-ramme-add]');
    if (!knap) return;
    saet(box.querySelector('[data-mm-ramme-txt]'), (knap.dataset.tekst || '[x]').replace('[x]', (k.dataset.navn || '').toLowerCase()));
    saet(box.querySelector('[data-mm-ramme-foer]'), k.dataset.foer || '');
    saet(box.querySelector('[data-mm-ramme-nu]'), k.dataset.nu || '');
  };

  const tjek = () => {
    const bokse = d.querySelectorAll('[data-mm-ramme]');
    if (!bokse.length) return;
    const fns = funnels();
    bokse.forEach((box) => {
      const pct = Number(box.dataset.pct) || 0;
      let antal = 0;
      box.querySelectorAll('[data-mm-ramme-valg]').forEach((k) => {
        const fn = tilbud(k.dataset.vid, fns);
        const ok = !fns.length || (!!fn && fn.upsell.discountType === 'PERCENTAGE' && Math.round(Number(fn.upsell.discountValue)) >= pct);
        if (k.hidden !== !ok) k.hidden = !ok;
        if (ok) { if (fn && k.dataset.fn !== fn.id) k.dataset.fn = fn.id; antal += 1; }
      });
      const valgt = box.querySelector('[data-mm-ramme-valg][aria-checked="true"]:not([hidden])') || box.querySelector('[data-mm-ramme-valg]:not([hidden])');
      if (valgt) vaelg(valgt);
      if (box.hidden !== (antal === 0)) box.hidden = antal === 0;
    });
  };

  const tilfoej = async (knap) => {
    const box = knap.closest('[data-mm-ramme]');
    const k = box && box.querySelector('[data-mm-ramme-valg][aria-checked="true"]');
    const fejl = box && box.querySelector('[data-mm-ramme-fejl]');
    if (!k || knap.disabled) return;
    const skuffe = box.closest('cart-drawer');
    const props = k.dataset.fn ? { __essential_upsell_funnel_id: k.dataset.fn, __essential_upsell_product_id: String(k.dataset.pid) } : {};
    const body = { items: [{ id: Number(k.dataset.vid), quantity: 1, properties: props }] };
    if (skuffe && skuffe.getSectionsToRender) { body.sections = skuffe.getSectionsToRender().map((s) => s.id); body.sections_url = window.location.pathname; }
    knap.disabled = true;
    knap.classList.add('is-busy');
    if (fejl) fejl.hidden = true;
    try {
      const url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
      const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
        .then((r) => r.json());
      if (res.status) throw new Error(res.description || res.message || '');
      try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mm-kurv-ramme', productVariantId: Number(k.dataset.vid), cartData: res }); } catch (e) { /* ignorer */ }
      if (skuffe && res.sections && skuffe.renderContents) skuffe.renderContents(res);
      else window.location.reload();
    } catch (e) {
      knap.disabled = false;
      knap.classList.remove('is-busy');
      if (fejl) { fejl.textContent = knap.dataset.fejl || ''; fejl.hidden = false; }
    }
  };

  d.addEventListener('click', (e) => {
    const k = e.target.closest('[data-mm-ramme-valg]');
    if (k) { vaelg(k); return; }
    const knap = e.target.closest('[data-mm-ramme-add]');
    if (knap) { tilfoej(knap); return; }
    const link = e.target.closest('[data-mm-maengde-link]');
    if (link) {
      const skuffe = link.closest('cart-drawer');
      let sti = '';
      try { sti = new URL(link.href, window.location.href).pathname; } catch (err) { sti = ''; }
      if (skuffe && sti && sti === window.location.pathname && skuffe.close) {
        e.preventDefault();
        skuffe.close();
        window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
    }
  });
  // piletasterne flytter valget mellem rammerne (radiogruppe)
  d.addEventListener('keydown', (e) => {
    const k = e.target.closest && e.target.closest('[data-mm-ramme-valg]');
    if (!k || !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) return;
    const alle = Array.from(k.parentElement.querySelectorAll('[data-mm-ramme-valg]:not([hidden])'));
    const i = alle.indexOf(k) + (e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 1);
    const ny = alle[(i + alle.length) % alle.length];
    if (ny) { e.preventDefault(); vaelg(ny); ny.focus(); }
  });

  const start = () => {
    tjek();
    if (!window.MutationObserver) return;
    let ventende = false;
    const igen = () => { if (ventende) return; ventende = true; requestAnimationFrame(() => { ventende = false; tjek(); }); };
    const skuffe = d.querySelector('cart-drawer');
    if (skuffe) new MutationObserver(igen).observe(skuffe, { childList: true, subtree: true });
    const side = d.getElementById('main-cart-items');
    if (side) new MutationObserver(igen).observe(side, { childList: true, subtree: true });
  };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start);
  else start();
})();
